const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://80.93.62.172:5000';

export const apiLogin = (username, password) =>
  fetch(`${BACKEND_URL}/api/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password })
  }).then(res => res.json());

export const apiMe = (token) =>
  fetch(`${BACKEND_URL}/api/me`, {
    headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
  }).then(res => res.json());

export const apiChangePassword = (token, currentPassword, newPassword) =>
  fetch(`${BACKEND_URL}/api/change-password`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ currentPassword, newPassword })
  }).then(res => res.json());

export const apiGetProjects = () =>
  fetch(`${BACKEND_URL}/api/projects`).then(res => res.json());

export const apiGetManagers = () =>
  fetch(`${BACKEND_URL}/api/managers`).then(res => res.json());

export const apiGetReports = (token) =>
  fetch(`${BACKEND_URL}/api/reports`, {
    headers: { 'Authorization': `Bearer ${token}` }
  }).then(res => res.json());

export const apiSubmitTimesheet = (token, reports) =>
  fetch(`${BACKEND_URL}/api/timesheet`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ reports })
  }).then(res => res.json());

export const apiSubmitOvertime = (token, report) =>
  fetch(`${BACKEND_URL}/api/overtime`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ report })
  }).then(res => res.json());

// Редактирование отчёта о переработке (доступно до 0:00 дня создания)
export const apiUpdateOvertime = (token, reportId, report) =>
  fetch(`${BACKEND_URL}/api/overtime/${reportId}`, {
    method: 'PUT',
    headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ report })
  }).then(res => res.json());

// Удаление отчёта о переработке
export const apiDeleteOvertime = (token, reportId) =>
  fetch(`${BACKEND_URL}/api/overtime/${reportId}`, {
    method: 'DELETE',
    headers: { 'Authorization': `Bearer ${token}` }
  }).then(res => res.json());

// Досрочная отправка отчёта в таблицу (экспорт)
export const apiSubmitOvertimeEarly = (token, reportId) =>
  fetch(`${BACKEND_URL}/api/overtime/${reportId}/submit`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${token}` }
  }).then(res => res.json());

export const apiGetUsers = (token) =>
  fetch(`${BACKEND_URL}/api/users`, {
    headers: { 'Authorization': `Bearer ${token}` }
  }).then(res => res.json());

export const apiCreateUser = (token, userData) =>
  fetch(`${BACKEND_URL}/api/register`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(userData)
  }).then(res => res.json());

export const apiUpdateUser = (token, userId, userData) =>
  fetch(`${BACKEND_URL}/api/users/${userId}`, {
    method: 'PUT',
    headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(userData)
  }).then(res => res.json());

export const apiDeleteUser = (token, userId) =>
  fetch(`${BACKEND_URL}/api/users/${userId}`, {
    method: 'DELETE',
    headers: { 'Authorization': `Bearer ${token}` }
  }).then(res => res.json());

export const apiResetPassword = (token, userId) =>
  fetch(`${BACKEND_URL}/api/users/${userId}/reset-password`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${token}` }
  }).then(res => res.json());

export const apiAdminStats = (token) =>
  fetch(`${BACKEND_URL}/api/admin/stats`, {
    headers: { 'Authorization': `Bearer ${token}` }
  }).then(res => res.json());
